module.exports = __webpack_public_path__ + "img/settings_fr.d2e1c67d.png";